<mat-dialog-content>
    <form [formGroup]="form">
        <h3>Edit Pricing Rule</h3>

        <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" required>
                <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
            </mat-form-field>

            <div class="form-row" style="display: flex; gap: 16px; width: 100%;">
                <mat-form-field appearance="outline" class="date-field half-width">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="startPicker" formControlName="startDate">
                    <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                    <mat-error *ngIf="form.get('startDate')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="date-field half-width">
                    <mat-label>End Date</mat-label>
                    <input matInput [matDatepicker]="endPicker" formControlName="endDate">
                    <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                    <mat-error *ngIf="form.get('endDate')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <div class="full-width priority-section">
                <mat-label>
                    <p class="form-label">Priority <mat-icon
                            matTooltip="Lower number = higher priority (1–9). Your default price has priority = 10">info</mat-icon>
                    </p>
                </mat-label>

                <mat-slider min="1" max="9" step="1" discrete showTickMarks thumbLabel class="full-width-slider">

                    <input matSliderThumb formControlName="priority">
                </mat-slider>

                <mat-hint align="start">
                    Current priority: {{ form.get('priority')?.value || '—' }}
                </mat-hint>

                <mat-error *ngIf="form.get('priority')?.hasError('required')">
                    Priority is required
                </mat-error>
                <mat-error *ngIf="form.get('priority')?.hasError('min') || form.get('priority')?.hasError('max')">
                    Must be between 1 and 9
                </mat-error>
            </div>

            <div class="full-width days-section">
                <mat-label class="days-label">
                    <p class="form-label">Days of the Week</p>
                </mat-label>
                <div class="days-checkbox-group">
                    <mat-checkbox *ngFor="let day of days"
                        [checked]="form.get('daysOfWeek')?.value?.includes(day.value)"
                        (change)="toggleDay(day.value, $event.checked)" color="primary">
                        {{ day.label }}
                    </mat-checkbox>
                </div>
                <mat-hint>{{ selectedDaysLabel }}</mat-hint>
            </div>

            <div class="full-width pricing-type-section">
                <mat-label>
                    <p class="form-label">Pricing Type <mat-icon
                            matTooltip="   Choose fixed nightly rate or percentage multiplier on base price">info</mat-icon>
                    </p>
                </mat-label>

                <mat-button-toggle-group formControlName="pricingType" (change)="onPricingTypeChange($event.value)">

                    <mat-button-toggle value="fixed">Fixed Price</mat-button-toggle>
                    <mat-button-toggle value="multiplier">Multiplier</mat-button-toggle>
                </mat-button-toggle-group>

                <mat-hint>
                    Choose fixed nightly rate or percentage multiplier on base price
                </mat-hint>
            </div>

            <ng-container *ngIf="form.get('pricingType')?.value === 'fixed'">
                <mat-form-field appearance="outline" class="form-field full-width">
                    <mat-label>Fixed Price (per night)</mat-label>
                    <input matInput formControlName="price" type="number" min="0" step="0.01" required>
                    <mat-icon matPrefix>attach_money</mat-icon>
                    <mat-error
                        *ngIf="form.get('price')?.hasError('required') || form.get('price')?.hasError('priceRequired')">
                        Required for fixed pricing
                    </mat-error>
                    <mat-error *ngIf="form.get('price')?.hasError('min')">
                        Must be ≥ 0
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <ng-container *ngIf="form.get('pricingType')?.value === 'multiplier'">
                <mat-form-field appearance="outline" class="form-field full-width">
                    <mat-label>Price Multiplier</mat-label>
                    <input matInput formControlName="priceMultiplier" type="number" min="0.1" step="0.01" required>
                    <mat-icon matPrefix>close</mat-icon>
                    <mat-hint>e.g., 1.2 = +20% on base rate</mat-hint>
                    <mat-error
                        *ngIf="form.get('priceMultiplier')?.hasError('required') || form.get('priceMultiplier')?.hasError('multiplierRequired')">
                        Required for multiplier pricing
                    </mat-error>
                    <mat-error *ngIf="form.get('priceMultiplier')?.hasError('min')">
                        Must be ≥ 0.1
                    </mat-error>
                </mat-form-field>
            </ng-container>

        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-flat-button class="metallic-text-btn-red" (click)="onCancel()">Cancel</button>
    <button mat-flat-button class="metallic-text-btn-blue" [disabled]="form.invalid" (click)="onSave()">
        Save
    </button>
</mat-dialog-actions>